import React, { FC } from 'react';

import { Link, styled, Typography, Stack } from '@mui/material';
import { ShuffleAngular } from 'phosphor-react';

import {
  IconLiFinanceLogo,
  IconArbitrumLogo,
  IconSynapseLogo,
  IconAcrossLogo,
  IconSquidLogo,
} from '~components/shared/icons';
import AppColors, { primaryColors } from '~components/theme/styles/colors';
import { columnGap } from '~components/theme/styles/mixins';
import { BRIDGE_CONFIG } from '~config/bridgeConfig';

import { useAccountDial } from '../../provider';
import { AccountPanel } from '../accountPanel';
import { AccountPanelOption } from '../accountPanelOption';

import { LifiModal } from './lifiModal';

export const StyledLink = styled(Link)({
  textDecoration: 'none',
  fontWeight: '600',
  color: AppColors.neutralGrey[3],
});

export const AccountDialBridges: FC<{ forceOpen?: boolean }> = ({ forceOpen }) => {
  const { setIsLifiWidgetOpen } = useAccountDial();

  return (
    <AccountPanel
      titleContent="Bridges"
      titleIcon={<ShuffleAngular size={22} color={primaryColors[400]} />}
      forceOpen={forceOpen}
    >
      <Stack sx={{ ...columnGap(16) }}>
        <StyledLink>
          <AccountPanelOption
            onClick={() => {
              setIsLifiWidgetOpen(true);
            }}
            sx={{ display: 'flex', justifyContent: 'start', gap: '16px', alignItems: 'center' }}
          >
            <IconLiFinanceLogo width={24} height={24} />
            <Typography variant={'label3'} sx={{ color: primaryColors[400] }}>
              {BRIDGE_CONFIG.LIFI.name}
            </Typography>
          </AccountPanelOption>
        </StyledLink>
        <StyledLink href={BRIDGE_CONFIG.SYN.url} target="_blank" rel="noopener noreferrer">
          <AccountPanelOption
            sx={{ display: 'flex', justifyContent: 'start', gap: '16px', alignItems: 'center' }}
          >
            <IconSynapseLogo width={24} height={24} />
            <Typography variant={'label3'} sx={{ color: primaryColors[400] }}>
              {BRIDGE_CONFIG.SYN.name}
            </Typography>
          </AccountPanelOption>
        </StyledLink>
        <StyledLink href={BRIDGE_CONFIG.ARB.url} target="_blank" rel="noopener noreferrer">
          <AccountPanelOption
            sx={{ display: 'flex', justifyContent: 'start', gap: '16px', alignItems: 'center' }}
          >
            <IconArbitrumLogo width={24} height={24} />
            <Typography variant={'label3'} sx={{ color: primaryColors[400] }}>
              {BRIDGE_CONFIG.ARB.name}
            </Typography>
          </AccountPanelOption>
        </StyledLink>
        <StyledLink href={BRIDGE_CONFIG.ACROSS.url} target="_blank" rel="noopener noreferrer">
          <AccountPanelOption
            sx={{ display: 'flex', justifyContent: 'start', gap: '16px', alignItems: 'center' }}
          >
            <IconAcrossLogo width={24} height={24} />
            <Typography variant={'label3'} sx={{ color: primaryColors[400] }}>
              {BRIDGE_CONFIG.ACROSS.name}
            </Typography>
          </AccountPanelOption>
        </StyledLink>
        <StyledLink href={BRIDGE_CONFIG.SQUID.url} target="_blank" rel="noopener noreferrer">
          <AccountPanelOption
            sx={{ display: 'flex', justifyContent: 'start', gap: '16px', alignItems: 'center' }}
          >
            <IconSquidLogo width={24} height={24} />
            <Typography variant={'label3'} sx={{ color: primaryColors[400] }}>
              {BRIDGE_CONFIG.SQUID.name}
            </Typography>
          </AccountPanelOption>
        </StyledLink>
      </Stack>
      <LifiModal />
    </AccountPanel>
  );
};
